import { Notifications } from "~/components/admin/operations";
import PageMeta from "~/components/common/meta";

export const ScreenNotifications = () => {
  return (
    <>
      <PageMeta
        title="Notifications | Art Handler"
        description="Notifications"
      />
      <Notifications />
    </>
  );
};
